import { useCustomerContactsQuery } from '@/dealers/_gen/gql'
import A from '@/gf/components/A'
import Action from '@/gf/components/Action'
import useToggle from '@/gf/hooks/useToggle'
import Phone from '@/gf/modules/Phone'
import { PhoneIcon, PlusIcon, UserIcon } from '@heroicons/react/20/solid'
import AddContactModal from './AddContactModal'

const Contacts = ({ customerAccountId }: { customerAccountId: string }) => {
  const { data, refetch } = useCustomerContactsQuery({ variables: { id: customerAccountId } })
  const [addContactOpen, addContactToggler] = useToggle()
  const contacts = data?.customer.contacts ?? []

  return (
    <>
      {data?.customer && (
        <AddContactModal
          customerAccountId={customerAccountId}
          customerName={data.customer.name}
          open={addContactOpen}
          onClose={addContactToggler.off}
          onAdded={() => refetch()}
        />
      )}

      <div className="flex justify-between items-center">
        <h3 className="flex items-center font-black text-xl text-slate-600">Contacts</h3>

        {/* Rendered on every customer account, claimed or not. A claimed account
            is refused by the server on Save (GEA-2546) — deliberately, because a
            button that disappears reads as a bug. */}
        <Action.P onClick={addContactToggler.on}>
          <PlusIcon className="inline h-4 align-middle -mt-1" /> Add Contact
        </Action.P>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4 mt-4">
        {contacts.map((c) => (
          <li
            key={c?.id}
            className="bg-white rounded-lg border border-slate-200 shadow overflow-x-hidden"
          >
            <div className="flex h-full flex-col gap-y-1 border-l-4 border-gearflow p-2 relative">
              <span className="inline-flex gap-x-1.5">
                <UserIcon className="text-slate-400 inline h-5 flex-shrink-0" />
                <span>
                  <span className="block font-medium text-zinc-600">{c.name}</span>
                  <span className="block capitalize text-xs text-slate-500 italic">{c.email}</span>
                </span>
              </span>

              {c?.phoneNumber && (
                <span className="inline-flex items-center gap-x-1.5">
                  <PhoneIcon className="text-slate-400 inline h-5 flex-shrink-0" />
                  <A.T className="text-sm text-slate-600" href={`tel:${c.phoneNumber}`}>
                    {Phone.format(c.phoneNumber)}
                  </A.T>
                </span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}

export default Contacts
